import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { PQRTamanhoMinimoTurmaDto } from '../../dtos/pqr-tamanho-minimo-turma.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../caq-request/caq-request.service';

interface ListPQRTamanhoMinimoTurma {
  _embedded: {
    'pqr-tamanho-minimo-turma': PQRTamanhoMinimoTurmaDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRTamanhoMinimoTurmaService {
  private apiUrl = `${environment.apiUrl}/pqr-tamanho-minimo-turma`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRTamanhoMinimoTurma(): Observable<PQRTamanhoMinimoTurmaDto[]> {
    return this.caqRequestService
      .get<ListPQRTamanhoMinimoTurma>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-tamanho-minimo-turma']));
  }

  salvePQRTamanhoMinimoTurma(requisicao: PQRTamanhoMinimoTurmaDto) {
    return firstValueFrom(this.caqRequestService
      .put<PQRTamanhoMinimoTurmaDto>(`${this.apiUrl}/${requisicao.codPqrTamanhoMinimoTurma}`, requisicao)
      .pipe(map((response) => response)));
  }
}